import React from 'react';
import {Button, IconButton} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {FormattedMessage} from "react-intl";

type DownloadIconButtonProps = {
    onClick: () => void;
};

const DownloadButton: React.FC<DownloadIconButtonProps> = (props) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        props.onClick();
    }

    return (
        <Button
            variant="outlined"
            size="small"
            // @ts-ignore
            color={props.color || "secondary"}
            startIcon={<FileDownloadIcon/>}
            onClick={(e) => handleClick(e)}>
            <FormattedMessage id={'COMMON_DOWNLOAD'}/>
        </Button>
    );
};
export default DownloadButton;
